import { defineMessages } from "react-intl";

export const professional = defineMessages({
  create: {
    id: "professional.create",
    defaultMessage: "Nuovo professionista",
  },
  edit: {
    id: "professional.edit",
    defaultMessage: "Modifica professionista",
  },
});
